import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { RetailersService, RetailerResponse, InventoryResponse, InventoriesService, InventoryRequest, BrandsService, BrandResponse } from '@src/app/shared/backend/clients';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-edit-inventory',
    templateUrl: './edit-inventory.component.html',
    styleUrl: './edit-inventory.component.scss',
    host: {
        class: 'app-edit-inventory'
    },
    standalone: false
})
export class EditInventoryComponent extends BaseViewComponent implements OnInit {

  inventoryId: number = 0;
  inventory: InventoryResponse = {};
  retailer: RetailerResponse = {};
  brand: BrandResponse = {};

  public inventoryForm: FormGroup = this.fb.group({
    referenceControl: ['', [Validators.required, Validators.maxLength(50)]],
    retailerControl: ['', [Validators.required]],
    commentControl: ['', [Validators.maxLength(255)]],
    brandControl: ['', [Validators.required]]
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private retailersService: RetailersService,
    private inventoriesService: InventoriesService,
    private brandsService: BrandsService,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {

    this.inventoryForm.controls['brandControl'].disable();
    this.inventoryForm.controls['retailerControl'].disable();

    this.route.params.subscribe(async params => {
      this.inventoryId = params['inventoryId'];

      if (this.inventoryId) {
        this.inventory = await firstValueFrom(this.inventoriesService.apiInventoriesIdGet(this.inventoryId));
        this.retailer = this.inventory.retailer?? await firstValueFrom(this.retailersService.apiRetailersIdGet(this.inventory.retailerId!));
        this.brand = this.inventory.brand?? await firstValueFrom(this.brandsService.apiBrandsIdGet(this.inventory.brandId!));

        this.initForm();
      }
    });
  }

  async initForm() {
    this.inventoryForm.controls['referenceControl'].setValue(this.inventory.name);
    this.inventoryForm.controls['commentControl'].setValue(this.inventory.comment);
    this.inventoryForm.controls['retailerControl'].setValue(this.retailer.name);
    this.inventoryForm.controls['brandControl'].setValue(this.brand.name);
  }

  async submitForm() {
    if (this.inventoryForm.valid) {
      const payload: InventoryRequest = {
        name: this.inventoryForm.controls['referenceControl'].value,
        retailerId: this.retailer.id!,
        comment: this.inventoryForm.controls['commentControl'].value,
        brandId: this.brand.id!
      };

      await firstValueFrom(this.inventoriesService.apiInventoriesUpdateIdPut(this.inventoryId, payload));

      this.router.navigate(['/inventories', this.inventoryId]);
    }
  }
}
